import cyclicFramesService from '../hid/cyclicFramesService';
import IqosCommunicatorClient from './iqosCommunicatorClient';

const processFrames = (props) => {
    writeFrameAndPublishResponse(props);
};

const writeFrameAndPublishResponse = ({
    frames,
    onSuccess,
    onError,
    timeout,
    skipErrorOnTimeout,
    isDebug = true,
    responseTimeoutMs,
    retryCount,
    doNotSplit,
    requestId,
    priority,
}) => {
    addFramesToQueue({
        frames,
        timeout,
        onSuccess: (responses) => {
            onSuccess?.(...responses);
        },
        onError,
        skipErrorOnTimeout,
        isDebug,
        responseTimeoutMs,
        retryCount,
        doNotSplit,
        requestId,
        priority,
    });
};

const createNew = () => {
    new IqosCommunicatorClient(true);
    cyclicFramesService.resetCyclicFrames();
};

const disable = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.disable();
    cyclicFramesService.resetCyclicFrames();
};

const restart = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.restartListeners();
};

const addFramesToQueue = (props) => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.addFramesToQueue(props);
};

const clear = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.clearResponseTimeout();
    iqosCommunicatorClient.clearQueue();
};

const cancelRequest = ({requestId, onCancel}) => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.cancelRequest(requestId, onCancel);
};

export default {
    clear,
    createNew,
    disable,
    processFrames,
    restart,
    writeFrameAndPublishResponse,
    addFramesToQueue,
    cancelRequest,
};
